import { ErrorInfo, Component } from "react";
import doLog from "./log";

interface IProps {
  module: string
  children: React.ReactElement
}

interface IState {
  hasError: boolean
}

class ErrorBoundary extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    if (error.message) {
      doLog("/sc.details.renderError", `module=${this.props.module}&message=${error.message}`, 'EXP');
    }
  }

  render() {
    if (this.state.hasError) {
      return false;
    }

    return this.props.children
  }
}

export default ErrorBoundary;